import dialogEdit from './dialogEdit'
import campaign from './campaign'
import entities from './entities'
import auth from './auth'
import snapshots from './snapshots'
import workspaces from './workspaces'
import selectedAssistant from './selectedAssistant'
import webChannel from './webChannel'
import reports from './reports'
import wordcloud from './wordcloud'
// filtros
import chatHistoryFilter from './filters/chat-history'
import eventAuthHistoryFilter from './filters/event-auth-history'
import analysisPerServiceDeliveredFilter from './filters/analysis-per-service-delivered'

export default {
  dialogEdit,
  campaign,
  entities,
  auth,
  snapshots,
  selectedAssistant,
  workspaces,
  webChannel,
  reports,
  chatHistoryFilter,
  eventAuthHistoryFilter,
  analysisPerServiceDeliveredFilter,
  wordcloud
}
